<template>
  <el-dialog custom-class="p-dialog-custom" append-to-body :title="title" :visible.sync="show" :width="width"
    :before-close="close" :close-on-click-modal="false">
    <el-form :model="form" :rules="rules" ref="ruleForm">
      <el-form-item prop="oldPassword">
        <div class="mobile"><el-input type="password" v-model="form.oldPassword" placeholder="请输入旧密码"></el-input></div>
      </el-form-item>
      <el-form-item prop="newPassword">
        <div class="mobile"><el-input type="password" v-model="form.newPassword" placeholder="请输入新密码"></el-input></div>
      </el-form-item>
      <el-form-item prop="confirmPassword">
        <div class="mobile"><el-input type="password" v-model="form.confirmPassword" placeholder="请输入确认密码"></el-input></div>
      </el-form-item>
    </el-form>
    <div class="yzm"><el-button type="primary" :disabled="loading" round @click="submit">提交</el-button></div>
  </el-dialog>
</template>

<script>
  import API from '@/api/user'
  import {
    isMobile
  } from '@/utils/validate'
  export default {
    props: {
      title: {
        //标题名称
        type: String,
        default: '修改密码'
      },
      content: {
        type: String
      },
      show: {
        type: Boolean,
        default () {
          return false;
        }
      },
      width: {
        type: String,
        default () {
          return '30%';
        }
      }
    },
    data() {
      const validatePass = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请输入密码"));
        } else if (value.includes(" ")) {
          callback(new Error("密码不得包含空格"));
        } else if (value.length > 20) {
          callback(new Error("密码不得超过20位"));
        } else if (value === this.form.oldPassword) {
          callback(new Error("新密码与旧密码重复"));
        } else {
          if (this.form.confirmPassword !== "") {
            this.$refs.ruleForm.validateField("confirmPassword");
          }
          callback();
        }
      };
      const validatePass2 = (rule, value, callback) => {
        if (value === "") {
          callback(new Error("请再次输入密码"));
        } else if (value !== this.form.newPassword) {
          callback(new Error("两次输入密码不一致!"));
        } else {
          callback();
        }
      };
      return {
        loading: false,
        btnTitle: '获取验证码',
        form: {
          oldPassword:'',
          newPassword:'',
          confirmPassword:''
        },
        rules: {
          oldPassword: [
            {
              required: true,
              message: "请输入旧密码",
              trigger: ["blur", "change"],
            },
          ],
          newPassword: [
            {
              type: "string",
              min: 6,
              message: "密码长度不得低于6位",
            },
            {
              validator: validatePass,
              trigger: "blur",
            },
          ],
          confirmPassword: [
            {
              validator: validatePass2,
              trigger: "blur",
            },
          ]
        }
      };
    },
    methods: {
      close(f) {
        this.$emit('close',f);
      },
      clear() {
        this.oldPassword=''
        this.newPassword=''
        this.confirmPassword=''
      },
      submit() {
        let self = this
        this.$refs['ruleForm'].validate(valid => {
          if (valid) {
            this.loading = true
            setTimeout(function() {
              self.loading = false
              self.updatePassword()
            }, 1000)
          }
        })
      },
      updatePassword(){
        API.updatePassword(this.form).then(res=>{
          if(res.data.code==200){
            this.$message.success('操作成功')
            this.close(true)
          }
        })
      }
    },
    mounted() {}
  };
</script>

<style lang="scss">
  .p-dialog-custom {
    // background-color: #03317d !important;

    .el-dialog__header {
      background-color: #1C6ED5;
      line-height: 16px !important;
      padding: 10px 20px;

      .el-dialog__title {
        color: #fff;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
      }

      .el-dialog__headerbtn {
        top: 12px;

        .el-dialog__close {
          font-size: 16px;
          color: #fff;
        }
      }
    }

    .el-dialog__body {
      color: #2B2E34;
      font-size: 14px;
      font-family: MicrosoftYaHei;
      font-weight: 600;

      .warning {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        background-color: #F29e0b;
        color: #fff;
        font-size: 18px;
        font-weight: bold;
        display: inline-block;
        text-align: center;
        margin-right: 16px;
        position: relative;

        &span {
          position: absolute;
        }
      }

      .el-form-item__error {
        margin-left: 50px !important;
      }

      .op6 {
        opacity: 0.6 !important;
      }

      .step {
        display: flex;
        justify-content: space-around;
      }

      .mobile {
        text-align: center;

        .el-input {
          width: 84%;

          .el-input__inner {
            border-radius: 20px !important;
          }
        }
      }

      .yzm {
        margin-top: 10px;
        text-align: center;

        .el-button {
          width: 84%;
        }
      }

      .num-txt {
        opacity: 1;
        display: flex;
        align-items: center;

        i {
          background-color: #1C6ED5;
          color: #fff;
          font-size: 28px;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-style: normal;
        }

        span {
          color: #1C6ED5;
          margin-left: 10px;
        }
      }

      .fh {
        display: flex;
        align-items: center;

        i {
          color: #1C6ED5;
          font-size: 28px;
        }
      }
    }

    .f-dialog-footer {
      .el-button--default {
        background-color: #A0B1D3;
        color: #FFFFFF;
        border-color: #A0B1D3;
      }

      .el-button--primary {
        background-color: #1C6ED5;
        color: #FFFFFF;
        border-color: #1C6ED5;

      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/project/components/nanwang/updatePassword.vue